import styled from 'styled-components';

const IconTwitterStyled = styled.svg`
  fill: ${props =>
    props.invert ? props.theme.colors.bg : props.theme.colors.icon};
`;

export default IconTwitterStyled;
